import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { SignupViewModel } from './SignupViewModel';
import { SignupCard } from './components/SignupCard';
import { AuthenticationScreenWrapper } from '../Components/AuthenticationLayout';
import { FlexColumn } from 'styleguide/Column';
import { View } from 'styleguide/View';
import { ShowOnPhoneDiv } from 'components/mobileVsDesktopShowHideHelpers';
import { Spacing } from 'styleguide/spacing';

import { SignupMarketingContent } from './components/SignupMarketingContent';
import { useGoogleLogin } from '@react-oauth/google';

export const SignupScreen = observer(({ showMoreInfo }: { showMoreInfo?: boolean }) => {
  const [vm] = useState(() => new SignupViewModel());
  const onGoogleSignUp = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: vm.onSignupWithGoogleClick,
    onError: vm.onGoogleSignupError,
  });

  return (
    <AuthenticationScreenWrapper contentContainerStyle={{ marginRight: 0, marginLeft: 0 }}>
      <FlexColumn id="signup-card" style={{ alignItems: 'center', width: '100%' }}>
        <View style={{ marginLeft: Spacing.md, marginRight: Spacing.md, marginBottom: Spacing.lg }}>
          <SignupCard
            email={vm.email}
            onUpdateUsername={vm.onUpdateUsername}
            username={vm.username}
            onUpdateEmail={vm.onUpdateEmail}
            emailErrorStatus={vm.emailErrorStatus}
            usernameErrorStatus={vm.usernameErrorStatus}
            password={vm.password}
            onUpdatePassword={vm.onUpdatePassword}
            passwordErrorStatus={vm.passwordErrorStatus}
            isLoading={vm.isLoading}
            onSignup={vm.onSignupPress}
            signupErrorMessage={vm.errorMessage}
            usernameEmailExistsErrorType={vm.usernameEmailExistsErrorType}
            onGoogleSignup={onGoogleSignUp}
            onAppleSignup={vm.onSignupWithAppleClick}
            onUpdateAcceptTerms={vm.onUpdateAcceptTerms}
            isTermsAccepted={vm.isTermsAccepted}
            termsErrorStatus={vm.acceptTermsErrorStatus}
            showAccountLinks={true}
          />
        </View>
        {showMoreInfo && (
          <ShowOnPhoneDiv style={{ width: '100%' }}>
            <SignupMarketingContent />
          </ShowOnPhoneDiv>
        )}
      </FlexColumn>
    </AuthenticationScreenWrapper>
  );
});
